module.exports = __webpack_public_path__ + "static/media/Arimo-Regular.9fe23bf2.ttf";